import clsx from 'clsx'
import { Fragment } from 'react'
import Image from 'next/image'

import Carousel from '@/cmp/organism/Carousel/Carousel'

interface Props {
  class?: string
  title: string
  testimonials: StrapiTestimonialAttributes[]
  theme?: 'dark' | 'light'
}

function Testimonials({
  theme = 'dark',
  title,
  testimonials,
  ...props
}: Props): JSX.Element {
  return (
    <section
      className={clsx(
        props.class,
        theme === 'dark' ? 'bg-blue-web-90 text-white' : 'text-black',
        'py-18'
      )}
    >
      <div className="font-heading container">
        <h3 className="text-3xl font-semibold lg:font-medium | lg:text-center | mb-10 lg:mb-14">
          {title}
        </h3>
        {testimonials.length > 0 ? (
          <Carousel
            autoScroll
            sliderClassName={clsx(
              'rounded-xl | flex flex-col justify-between gap-5 lg:gap-10 |  min-w-[20rem] h-64 lg:h-[25rem] | p-4 lg:p-7 mr-9 lg:mr-8 | font-heading',
              theme === 'light' ? 'bg-blue-90 text-white' : 'bg-blue-web-27'
            )}
            slides={testimonials.map(value => {
              return <TestimonialCard key={value.authorName} {...value} />
            })}
          />
        ) : null}
      </div>
    </section>
  )
}

function TestimonialCard(value: StrapiTestimonialAttributes): JSX.Element {
  return (
    <Fragment>
      {value.companyImage ? (
        <div className="relative | min-w-full">
          <Image
            alt={value.companyImage.data?.attributes.alternativeText ?? ''}
            className="h-full w-auto"
            src={value.companyImage.data?.attributes.url ?? ''}
            width={value.companyImage.data?.attributes.width}
            height={value.companyImage.data?.attributes.height}
          />
        </div>
      ) : null}

      {value.review ? (
        <p className="text-base lg:text-2xl | line-clamp-5">
          {value.review.replace(/```/g, '')}
        </p>
      ) : null}
      <div className="flex items-center gap-3 lg:gap-6">
        {value.authorImage ? (
          <div className="w-9 lg:w-18">
            <Image
              className="rounded-full"
              alt={value.authorName}
              src={value.authorImage.data?.attributes.url ?? ''}
              width={value.authorImage.data?.attributes.width}
              height={value.authorImage.data?.attributes.height}
            />
          </div>
        ) : null}
        <div className="w-full">
          <h4 className="text-xs lg:text-base">{value.authorName}</h4>
          <p className="text-small lg:text-sm | line-clamp-2">
            {value.authorDesignation}
          </p>
        </div>
      </div>
    </Fragment>
  )
}

export default Testimonials
